// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import objectiveCheckInEntity from './entities/objective-check-in.json';
import objectiveCheckInMenu from '../pages/objective-check-in/menu.json';
import objectiveCheckInFullForm from '../pages/objective-check-in/forms/full.json';
import objectiveCheckInContextForm from '../pages/objective-check-in/forms/context.json';
import objectiveCheckInMiniForm from '../pages/objective-check-in/forms/mini.json';
import objectiveCheckInLookupForm from '../pages/objective-check-in/forms/lookup.json';
import objectiveCheckInTableView from '../pages/objective-check-in/views/table.json';
import objectiveCheckInCardsView from '../pages/objective-check-in/views/cards.json';
import objectiveCheckInDashboardView from '../pages/objective-check-in/views/dashboard.json';

/** Тип запису «Звіт про поступ» зі сторінками пакета: меню, форми та подання з pages/objective-check-in/. */
export const objectiveCheckInDefinition: IRecordTypeDefinition = {
  ...objectiveCheckInEntity,
  views: assembleViewSet({
      table: objectiveCheckInTableView,
      cards: objectiveCheckInCardsView,
      dashboard: objectiveCheckInDashboardView,
  }),
  form: objectiveCheckInFullForm,
  forms: { full: objectiveCheckInFullForm, context: objectiveCheckInContextForm, mini: objectiveCheckInMiniForm, lookup: objectiveCheckInLookupForm },
  menu: objectiveCheckInMenu,
} as IRecordTypeDefinition;
